/********************************************************************
 * Project: WDCK（2021）
 * Class: LanguageDatepickerService
 * ----------------------------------------
 * <summary>
 * LanguageDatepickerService
 * </summary>
 * <history>
 *      ThaiTV     2021/07/16      Create
 * </history>
 ********************************************************************/
import { Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import localeEn from '@angular/common/locales/en';
import localeJa from '@angular/common/locales/ja';
import localeVi from '@angular/common/locales/vi';
import { FormStyle, getLocaleDayNames, registerLocaleData, TranslationWidth } from '@angular/common';
import { LanguageTranslateService } from 'src/app/services/lang-translate.service';
import { Utility } from 'src/app/shared/utility/utility';

@Injectable()
export class LanguageDatepickerService extends NgbDatepickerI18n {
  // Provide labels in multiple languages
  arrayWeekday: any[] = [];
  arrayMonth: any[] = [];
  strDefaultLang: any;
  private locale: any;
  private weekdaysShort: readonly string[];
  constructor(
    private language: LanguageTranslateService,
    private ulti: Utility,
  ) {
    super();
    const strLanguageLocal = localStorage.getItem('language');
    if (!this.ulti.isNullOrEmpty(strLanguageLocal)) {
      this.strDefaultLang = strLanguageLocal;
    }
    if (this.strDefaultLang) {
      this.locale = this.strDefaultLang;
      switch (this.strDefaultLang) {
        case 'ja':
        case 'jp':
          this.locale = 'ja';
          registerLocaleData(localeJa);
          break;
        case 'vi':
        case 'vn':
          this.locale = 'vi';
          registerLocaleData(localeVi);
          break;
        case 'en':
          registerLocaleData(localeEn);
          break;
        default:
          registerLocaleData(localeEn);
          break;
      }
    } else {
      this.locale = 'en';
      registerLocaleData(localeEn);
    }
    const weekdaysStartingOnSunday = getLocaleDayNames(this.locale, FormStyle.Standalone, TranslationWidth.Short);
    this.weekdaysShort = weekdaysStartingOnSunday.map((day, index) => weekdaysStartingOnSunday[(index + 1) % 7]);
    this.arrayMonth = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
  }
  getWeekdayShortName(weekday: number): string {
    return this.weekdaysShort[weekday - 1] || '';
  }
  getMonthShortName(month: number): string {
    return this.arrayMonth[month - 1];
  }
  getMonthFullName(month: number, year?: number): string {
    return year + ' / ' + this.getMonthShortName(month);
  }
  getYearNumerals(year: number): string {
    return '';
  }
  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}/${date.month}/${date.year}`;
  }
}
